import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../../ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../../Util/axiosErrorHandler'
import { IAPIWorkingSchedule, IAbsence } from '../interface/IWorkingSchedule'
import { absenceTransformer } from '../transformer/workingScheduleTransformer'

export const fetchAbsences = createAsyncThunk<
  IAbsence[],
  undefined,
  IThunkReject<any>
>('workingAbsence/fetch', async (_, { rejectWithValue }) => {
  let absences: IAbsence[] = []

  try {
    // @todo: api/work-schedule -> endpoint has been deleted.
    // @todo: This call is only relevant for calendar-new. Calendar new will be re-written, so not relevant at all. calendar new is not in use by anyone.
    const promise = clientSDK
      .instance()
      .get<IAPIWorkingSchedule>('work-schedule')

    const result = await promise
    absences = absenceTransformer(result.data)
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return absences
})
